import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import { withStyles } from '@material-ui/styles';
import {
    Paper,
    Grid,
    IconButton,
    Stepper,
    StepButton,
    Divider,
    Typography,
    Link,
    Step,
    StepLabel,
    Button,
    CircularProgress
} from '@material-ui/core';

import Billing from '../Creation/components/Billing';
import Caracteristic from '../Creation/components/Caracteristic';
import Validation from '../Creation/components/Validation';

import { TabControl, MarketMap as Map } from './components';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { checkIntervalsBillPackage } from 'common/validators';

const steps = {
    caracteristic: {
        id: 0,
        link: 'caracteristic',
        label: 'Caractéristiques',
        previous: false,
        next: 'billing',
        error: false,
        completed: false
    },
    billing: {
        id: 1,
        link: 'billing',
        label: 'Facturation',
        next: 'plan',
        previous: 'caracteristic',
        error: false,
        completed: false
    },
    plan: {
        id: 2,
        link: 'plan',
        label: 'Plan',
        next: 'validation',
        previous: 'billing',
        error: false,
        completed: false
    },
    validation: {
        id: 3,
        link: 'validation',
        label: "Vue d'ensemble",
        next: false,
        previous: 'plan',
        error: false,
        completed: false
    }
};

const styles = theme => ({
    root: {
        padding: theme.spacing(4),
        flexGrow: 1
    },
    paperContent: {
        padding: theme.spacing(3)
    },
    labelFilter: {
        color: '#3f51b5',
        marginBottom: 15
    },
    isNotActive: {
        '& svg': {
            color: 'lightblue !important'
        }
    },
    completed: {
        '& svg': {
            color: 'green !important'
        }
    }
});

class Edit extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props,
            //id: props.args.args2,
            raz: false,
            init: true,
            underWay: false,
            steps: { ...steps },
            days: [],
            places: [],
            removedPlaces: [],
            merchants: [],
            activities: [],
            //selectedMerchants: [],
            isLoading: false,
            caracteristic: {
                label: '',
                day: '',
                placementMode: '',
                allowBlocked: '',
                type: '',
                active: true,
                adresse: null
            },
            billing: {
                billPackage: false,
                subscriber: '',
                noneSubscriber: '',
                water: '',
                noneSubscriberWater: '',
                truck: '',
                electricity: '',
                noneSubscriberElectricity: '',
                intervals: []
            }
        };
    }

    componentDidMount = () => {
        this.init();
    };

    componentDidUpdate = (prevProps, prevState) => {
        this.state.isLoading && this.state.isLoading != prevState.isLoading && this.sendData();

        this.state.raz && this.state.raz != prevState.raz && this.init();
    };

    init = () => {
        fetch(
            `https://www.${
                window.location.hostname.split('.')[1]
                    ? window.location.hostname.split('.')[0] === 'www'
                        ? window.location.hostname.split('.')[1]
                        : window.location.hostname.split('.')[0]
                    : 'dev'
            }.api.digitmarche.fr/api/market/init?id=${this.props.args.args2}`,
            {
                method: 'GET'
            }
        )
            .then(response => {
                return response.ok ? response.json() : false;
            })
            .then(data => {
                this.setState({
                    ...data,
                    init: false,
                    billing: {
                        ...data.billing,
                        billPackage: data.billPackage
                    },
                    raz: false
                });
            })
            .catch(
                error => {
                    console.error(error);
                    alert('Echec de la récupération des données');
                } // Handle the error response object
            );
    };

    setRaz = value => {
        const _confirm = window.confirm(
            "Le marché va être réinitialisé à ses valeurs d'origines.\nÊtes-vous sûr(e) de vouloir poursuivre cette action ?"
        );
        _confirm &&
            this.setState({
                raz: value
            });
    };

    prepareData = (node, value) => {
        this.setState({
            [node]: value
        });
    };

    convertLinkToStep = link => {
        return steps[link].id;
    };

    getBack = () => {
        const { history } = this.props;
        history.goBack();
    };

    getStepLinkButton = forward => {
        const { args1, args2 } = this.props.args;

        return {
            previous: steps[args1].previous,
            next: steps[args1].next
        };
    };

    hasErrorOnStep = (node, _bool) => {
        this.setState({
            steps: {
                ...steps,
                [node]: {
                    ...steps[node],
                    error: _bool
                }
            }
        });
    };

    StepIsValid = (node, _bool) => {
        this.setState({
            steps: {
                ...steps,
                [node]: {
                    ...steps[node],
                    done: _bool
                }
            }
        });
    };

    updateStepper = steps => {
        this.setState({
            steps: steps
        });
    };

    validate = () => {
        const { caracteristic, billing, steps, places } = this.state;
        let isValid = true;
        let newSteps = steps;
        let isLoading = true;

        Object.keys(caracteristic).map(index => {
            if (isValid) {
                if (index == 'adresse') {
                    if (!caracteristic[index]) {
                        alert('Veuillez saisir une adresse dans les caractéristiques du marché.');
                        isValid = false;
                        isLoading = false;
                        newSteps = {
                            ...newSteps,
                            caracteristic: {
                                ...newSteps.caracteristic,
                                error: true,
                                completed: false
                            }
                        };
                    } else {
                        newSteps = {
                            ...newSteps,
                            caracteristic: {
                                ...newSteps.caracteristic,
                                error: false,
                                completed: true
                            }
                        };
                    }
                } else {
                    //console.log(index, caracteristic[index]);
                    if (
                        caracteristic[index].length == 0 ||
                        (index == 'label' && !caracteristic[index].replace(/\s/g, '').length)
                    ) {
                        alert(
                            'Certains champs sont incorrects ou vides pour les caractéristiques du marché.'
                        );
                        isValid = false;
                        isLoading = false;
                        newSteps = {
                            ...newSteps,
                            caracteristic: {
                                ...newSteps.caracteristic,
                                error: true,
                                completed: false
                            }
                        };
                    } else {
                        newSteps = {
                            ...newSteps,
                            caracteristic: {
                                ...newSteps.caracteristic,
                                error: false,
                                completed: true
                            }
                        };
                    }
                }
            }
        });

        isValid = true;

        Object.keys(billing).map(index => {
            if (isValid) {
                // Forfait
                if (billing.billPackage) {
                    if (
                        index !== 'water' &&
                        index !== 'truck' &&
                        index !== 'electricity' &&
                        index !== 'subscriber' &&
                        index !== 'intervals' &&
                        index !== 'noneSubscriberWater' &&
                        index !== 'noneSubscriberElectricity' &&
                        index !== 'billPackage' &&
                        (!billing[index] ||
                            billing[index].length == 0 ||
                            !billing[index].replace(/\s/g, '').length)
                    ) {
                        alert(
                            'Certains champs sont incorrects ou vides pour la facturation du marché.'
                        );
                        isValid = false;
                        isLoading = false;
                        newSteps = {
                            ...newSteps,
                            billing: {
                                ...newSteps.billing,
                                error: true,
                                completed: false
                            }
                        };
                    } else if (index === 'intervals') {
                        if (checkIntervalsBillPackage(billing.intervals)) {
                            newSteps = {
                                ...newSteps,
                                billing: {
                                    ...newSteps.billing,
                                    error: false,
                                    completed: true
                                }
                            };
                        } else {
                            alert(
                                'Certains champs sont incorrects ou vides pour la facturation du marché.'
                            );
                            isValid = false;
                            isLoading = false;
                            newSteps = {
                                ...newSteps,
                                billing: {
                                    ...newSteps.billing,
                                    error: true,
                                    completed: false
                                }
                            };
                        }
                    }
                } else {
                    // Pas de forfait
                    if (
                        index != 'water' &&
                        index != 'truck' &&
                        index != 'electricity' &&
                        index != 'intervals' &&
                        index !== 'noneSubscriberWater' &&
                        index !== 'noneSubscriberElectricity' &&
                        index !== 'billPackage' &&
                        (!billing[index] ||
                            billing[index].length == 0 ||
                            !billing[index].replace(/\s/g, '').length)
                    ) {
                        alert(
                            'Certains champs sont incorrects ou vides pour la facturation du marché.'
                        );
                        isValid = false;
                        isLoading = false;
                        newSteps = {
                            ...newSteps,
                            billing: {
                                ...newSteps.billing,
                                error: true,
                                completed: false
                            }
                        };
                    } else {
                        newSteps = {
                            ...newSteps,
                            billing: {
                                ...newSteps.billing,
                                error: false,
                                completed: true
                            }
                        };
                    }
                }
            }
        });

        if (places.length == 0) {
            alert('Le marché doit comporter au moins une place afin de valider sa modification.');
            isLoading = false;
            newSteps = {
                ...newSteps,
                plan: {
                    ...newSteps.plan,
                    error: true,
                    completed: false
                }
            };
        } else {
            newSteps = {
                ...newSteps,
                plan: {
                    ...newSteps.plan,
                    error: false,
                    completed: true
                }
            };
        }

        this.setState({
            steps: newSteps,
            isLoading: isLoading
        });
    };

    /*updateMerchants = (value) => {
        this.setState({
            selectedMerchants: value
        })
    }*/

    sendData = () => {
        const { caracteristic, billing, places, merchants, removedPlaces } = this.state;

        const formData = new FormData();
        formData.append('merchants', JSON.stringify(merchants));
        formData.append('places', JSON.stringify(places));
        formData.append('removedPlaces', JSON.stringify(removedPlaces));
        formData.append('billing', JSON.stringify(billing));
        formData.append('caracteristic', JSON.stringify(caracteristic));

        fetch(
            `https://www.${
                window.location.hostname.split('.')[1]
                    ? window.location.hostname.split('.')[0] === 'www'
                        ? window.location.hostname.split('.')[1]
                        : window.location.hostname.split('.')[0]
                    : 'dev'
            }.api.digitmarche.fr/api/market/update-market/${this.props.args.args2}`,
            {
                method: 'POST',
                body: formData
            }
        )
            .then(response => {
                return response.ok ? response.json() : false;
            })
            .then(data => {
                alert('Marché mis à jour avec succès.');
                this.setState(prevState => ({
                    isLoading: false,
                    steps: {
                        ...prevState.steps,
                        validation: {
                            ...prevState.steps.validation,
                            completed: true,
                            error: false
                        }
                    }
                }));
                this.init();
                this.props.history.push(`/markets/edit/caracteristic/${data}`);
            })
            .catch(
                error => {
                    console.error(error);
                    alert('Echec de la mise à jour du marché.');
                    this.setState(prevState => ({
                        isLoading: false,
                        steps: {
                            ...prevState.steps,
                            validation: {
                                ...prevState.steps.validation,
                                completed: false,
                                error: true
                            }
                        }
                    }));
                } // Handle the error response object
            );
    };

    render() {
        const {
            classes,
            days,
            id,
            caracteristic,
            billing,
            steps,
            activities,
            places,
            merchants,
            isLoading,
            raz,
            underWay,
            init,
            removedPlaces
        } = this.state;

        const { args1, args2 } = this.props.args;

        const linkButton = this.getStepLinkButton();

        return (
            <Grid container direction="column" spacing={6}>
                <Grid item>
                    <Paper className={classes.paperContent}>
                        <Grid
                            container
                            direction="column"
                            justify="center"
                            alignItems="stretch"
                            spacing={2}>
                            <Grid item>
                                <Grid container direction="row" alignItems="baseline">
                                    <Grid item>
                                        <IconButton onClick={this.getBack}>
                                            <ArrowBackIcon />
                                        </IconButton>
                                    </Grid>
                                    <Grid item>
                                        <Typography>
                                            <Link component={RouterLink} to="/markets/all">
                                                Les marchés
                                            </Link>{' '}
                                            / Modifier un marché
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item>
                                <Divider />
                            </Grid>
                            <Grid item>
                                <Stepper
                                    nonLinear
                                    alternativeLabel
                                    activeStep={this.convertLinkToStep(args1)}>
                                    {Object.keys(steps).map(index => {
                                        return (
                                            <Step
                                                key={steps[index].id}
                                                completed={steps[index].completed}>
                                                <StepButton
                                                    component={RouterLink}
                                                    to={`/markets/edit/${steps[index].link}/${args2}`}>
                                                    <StepLabel
                                                        className={clsx({
                                                            [classes.completed]:
                                                                steps[index].completed
                                                        })}
                                                        error={steps[index].error}>
                                                        {steps[index].label}
                                                    </StepLabel>
                                                </StepButton>
                                            </Step>
                                        );
                                    })}
                                </Stepper>
                            </Grid>
                            <Grid item>
                                <Divider />
                            </Grid>
                            <Grid item>
                                <TabControl value={args1} index={'caracteristic'}>
                                    {!init ? (
                                        <Caracteristic
                                            edit
                                            data={caracteristic}
                                            node="caracteristic"
                                            updateData={this.prepareData}
                                            days={days}
                                        />
                                    ) : null}
                                </TabControl>
                                <TabControl value={args1} index={'billing'}>
                                    <Billing
                                        data={billing}
                                        node="billing"
                                        updateData={this.prepareData}
                                    />
                                </TabControl>
                                <TabControl value={args1} index={'plan'}>
                                    <Map
                                        history={this.props.history}
                                        id={args2}
                                        raz={raz}
                                        marketData={caracteristic}
                                        places={places}
                                        removedPlaces={removedPlaces}
                                        merchants={merchants}
                                        activities={activities}
                                        updateData={this.prepareData}
                                        //rebuildList={this.rebuildList}
                                    />
                                </TabControl>
                                <TabControl value={args1} index={'validation'}>
                                    <Validation
                                        steps={steps}
                                        days={days}
                                        edit
                                        //raz={raz}
                                        activities={activities}
                                        data={{
                                            caracteristic: caracteristic,
                                            billing: billing,
                                            places: places,
                                            merchants: merchants
                                        }}
                                        updateData={this.prepareData}
                                    />
                                </TabControl>
                            </Grid>
                            <Grid item>
                                <Divider />
                            </Grid>
                            <Grid item>
                                <Grid
                                    container
                                    justify="space-between"
                                    alignItems="center"
                                    spacing={2}>
                                    <Grid item>
                                        <Button
                                            disabled={isLoading}
                                            variant="outlined"
                                            color="primary"
                                            onClick={() => this.setRaz(true)}>
                                            Reinitialiser les valeurs
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        <Grid
                                            container
                                            justify="flex-end"
                                            alignItems="center"
                                            spacing={2}>
                                            {isLoading && (
                                                <Grid item>
                                                    <CircularProgress color="primary" size={25} />
                                                </Grid>
                                            )}
                                            <Grid item>
                                                <Button
                                                    disabled={!linkButton.previous || isLoading}
                                                    component={RouterLink}
                                                    variant="outlined"
                                                    to={`/markets/edit/${linkButton.previous}/${args2}`}>
                                                    Étape précédente
                                                </Button>
                                            </Grid>
                                            <Grid item>
                                                <Button
                                                    disabled={!linkButton.next}
                                                    color="primary"
                                                    variant="outlined"
                                                    component={RouterLink}
                                                    to={`/markets/edit/${linkButton.next}/${args2}`}>
                                                    Étape suivante
                                                </Button>
                                            </Grid>
                                            <Grid item>
                                                <Button
                                                    disabled={isLoading || underWay}
                                                    color="primary"
                                                    variant="contained"
                                                    onClick={this.validate}>
                                                    {underWay
                                                        ? 'Marché en cours'
                                                        : 'Valider les modifications'}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        );
    }
}

export default withStyles(styles)(Edit);
